export default __webpack_public_path__ + "static/media/efecto-2.9494c1d2.webp";